import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import PricingPresentation from 'components/PricingPresentation';
import Button from 'components/customDesign/Button';
import ReactGA from 'react-ga';
import { Link, useLocation, Navigate } from 'react-router-dom';
import { ReactComponent as ProfileIcon } from 'assets/icons/profile_icon.svg';
import CheckIcon from '@material-ui/icons/Check';
import { ShippingLine, ContainerType } from 'types/Shipping';
import { setPorts, setShippingLines, setContainerTypes } from 'ducks/erlData';
import { Routes } from 'constants/pages';
import Table from './components/Table';
import useStyles from './FreeTable.style';

interface Props {
  shippingLines: ShippingLine[];
  containerTypes: ContainerType[];
  isLoading: boolean;
  isLogged: boolean;
  isAdmin: boolean;
}

const FreeTable: React.FC<Props> = (props) => {
  const { shippingLines, containerTypes, isLoading, isLogged, isAdmin } = props;
  const location = useLocation();
  const classes = useStyles();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPorts());
    dispatch(setShippingLines());
    dispatch(setContainerTypes());
  }, [dispatch]);

  if (isLogged) return <Navigate replace to={Routes.EmptyReturnLocations} />;

  if (containerTypes.length > 0 && shippingLines.length > 0 && !isLoading) {
    ReactGA.event({
      category: 'Search',
      action: 'Empty search',
      label: `${shippingLines.map((sl: ShippingLine) => sl.name)} / ${shippingLines.map(
        (sl: ShippingLine) => sl.name
      )}`,
    });
  }

  return (
    <>
      <Typography align="center" variant="h2" className={classes.transitionText}>
        Thanks for trying!
      </Typography>
      <Table
        shippingLines={shippingLines.slice(0, 1)}
        containerTypes={containerTypes.slice(0, 1)}
        isLoading={isLoading}
        location={location}
      />
      <div className={classes.transistion}>
        <Typography align="center" variant="h2" className={classes.transitionText}>
          <b>Ready to use?</b> Access the full platform now!
        </Typography>
        <div className={classes.checklist}>
          <Typography className={classes.checklistItem}>
            <CheckIcon />
            15 days trial
          </Typography>
          <Typography className={classes.checklistItem}>
            <CheckIcon />
            No credit card required
          </Typography>
          <Typography className={classes.checklistItem}>
            <CheckIcon />
            Cancel anytime
          </Typography>
        </div>
        <Button
          classes={{ root: classes.buttonRoot }}
          rightIcon={<ProfileIcon className={classes.buttonIcon} />}
          /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
          /* @ts-ignore */
          component={Link}
          to="/signup"
        >
          Try 15 days free
        </Button>
      </div>
      <PricingPresentation isAdmin={isAdmin} showPlanButtons={false} showFreeTrialButtons />
    </>
  );
};

export default FreeTable;
